module.exports = __webpack_public_path__ + "img/persona_01.c1810c8d.png";